<template>
  <div v-if="status" >
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <i aria-hidden="true" v-on="on"
           :class="'v-icon notranslate material-icons theme--dark ' + color + '--text'">{{ status }}</i>
      </template>
      <span>{{statusText}}</span>
    </v-tooltip>
  </div>
  <div v-else>
    ~
  </div>
</template>

<script>
const BUTTON_CONTENT_SIGN = 'speaker';
const ADVERT_SIGN = 'lightbulb';
export default {
  name: "StatusField",
  props: {
    item: {}
  },
  computed: {
    statusText() {
      let statusText = '';
      if (this.status == BUTTON_CONTENT_SIGN && this.color == 'green') {
        statusText = this.$t('display/advert:overview.tooltip.b-content-in-use');
      } else if (this.status == ADVERT_SIGN && this.color == 'green') {
        statusText = this.$t('display/advert:overview.tooltip.advert-normally');
      } else if (this.status == ADVERT_SIGN && this.color == 'yellow') {
        statusText = this.$t('display/advert:overview.tooltip.advert-played-no-budget');
      } else if (this.status == ADVERT_SIGN && this.color == 'red') {
        statusText = this.$t('display/advert:overview.tooltip.advert-not-played-end-date');
      } else if (this.status == BUTTON_CONTENT_SIGN && this.color == 'black') {
        statusText = this.$t('display/advert:overview.tooltip.button-not-use');
      } else if (this.status == ADVERT_SIGN && this.color == 'black') {
        statusText = this.$t('display/advert:overview.tooltip.advert-not-played');
      } else if (this.status == ADVERT_SIGN && this.color == 'grey') {
        statusText = this.$t('display/advert:overview.tooltip.advert-not-played-constraints');
      }

      return statusText;
    }

  },
  data() {
    return {
      status: null,
      color: 'primary'
    }

  },
  methods: {
    calculateStatus() {
      if (this.item.budget === null || this.item.playedBudget === null || this.item.dateEnd === null) {
        return;
      }

      let playlist = this.item.inPlaylist === true;
      let budget = (parseFloat(this.item.budget) - parseFloat(this.item.playedBudget)) > 0;
      let buttonContent = this.item.buttonContent === 'BUTTON_CONTENT';

      let dateEnd = this.item.dateEnd;
      let tmpdate = new Date(
        dateEnd.substr(6, 10),
        dateEnd.substr(3, 2),
        dateEnd.substr(0, 2));
      tmpdate.setMonth(tmpdate.getMonth() - 1); //months go from 0-11, so we have to subtract 1

      let enddateInFuture = tmpdate > new Date();

      //green
      //in playlist && (hasBudget && enddate future) || (button content)
      if (playlist && ((budget && enddateInFuture) || buttonContent)) {
        if (buttonContent) {
          this.status = BUTTON_CONTENT_SIGN;
          this.color = 'green';
          return;
        } else {
          this.status = ADVERT_SIGN;
          this.color = 'green';
          return;
        }
      }

      //yellow
      //in playlist && (no Budget && enddate future)
      else if (playlist && (!budget && enddateInFuture)) {
        this.status = ADVERT_SIGN;
        this.color = 'yellow';
        return;
      }

      //red
      //no playlist && (has Budget && enddate done)
      else if (!playlist && (budget && !enddateInFuture)) {
        this.status = ADVERT_SIGN;
        this.color = 'red';
        return;
      }

      //black
      //no playlist && (no Budget && enddate done) || (button content)
      else if (!playlist && ((!budget && !enddateInFuture) || buttonContent)) {
        if (buttonContent) {
          this.status = BUTTON_CONTENT_SIGN;
          this.color = 'black';
          return;
        } else {
          this.status = ADVERT_SIGN;
          this.color = 'black';
          return;
        }
      }

      //white
      //if we have some other constraints stopping the advert from being displayed
      else {
        this.status = ADVERT_SIGN;
        this.color = 'grey';
        return;
      }
    }
  },
  created() {
    this.calculateStatus();
  }
}
</script>